import Vue from 'vue'
import Vuex from 'vuex'
import { getAllMedias, getMediaById, getInfosMeta, updateMediaById, postMedia, deleteMedia } from '../api/media.api';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiKey: "",
    isLogged : false,
    keyIsValid: false,
    dialog : false,
    dialogCreate : false,
    dialogGenerate : false,
    arrMedias: [],
    displayedMedia: 0,
    mediaTotal : 0,
    mediaPage: 1,
    arrFilters: [],
    listItems: [],
    mediaDetails : {
      title: "",
      meta: {
        ref: [],
        name: [],
        type: [],
        brand: [],
        utilisation: [],
        group: [],
        product: [],
        tags: [],
        environnement: [],
        comment: []
      },
      fileinfo: {
        size: 0,
        image : {
          x:0,
          y:0
        }
      }
    },
    infosMetas: {},
  },
  mutations: {
    setApiKey(state, value){
      state.apiKey = value
    },
    setKeyIsValid(state, value){
      state.keyIsValid = value
    },
    setIsLogged(state, value){
      state.isLogged = value
    },
    setDialog(state, value){
      state.dialog = value
    },
    setDialogCreate(state, value){
      state.dialogCreate = value
    },
    setDialogGenerate(state, value){
      state.dialogGenerate = value
    },
    initArrayMedias(state, value){
      state.arrMedias = value;
    },
    addArrayMedias(state, value){
      value.forEach((media) => {
        state.arrMedias.push(media)
      })
    },
    initArrayFilters(state, value){
      state.arrFilters = value;
    },
    initListItems(state, value){
      state.listItems = value;
    },
    setMediaDetail(state, value){
      state.mediaDetails = value
    },
    updateMediaDetails(state, value){
      state.mediaDetails = value
    },
    updateMediaList(state, payload){
      const index = state.arrMedias.findIndex((element) => element.id == payload.id)
      state.arrMedias[index].title = payload.title;
      state.arrMedias[index].meta = payload.meta;

    },
    addMediaToList(state, media){
      state.arrMedias.push(media)
    },
    deleteMediaFromList(state, mediaId){
      const indexToDelete = state.arrMedias.findIndex((e) =>  e.id == mediaId);
      state.arrMedias.splice(indexToDelete, 1);
    },
    initInfosMetas(state, value){
      state.infosMetas = value
    },
    setMediaDisplayed(state, value){
      state.displayedMedia = state.arrMedias.length
    },
    setTotalMedias(state, value){
      state.mediaTotal = value
    }
  },
  actions: {
    async initInfosMetas({commit}){
      try {
        const response = await getInfosMeta();
        commit('initInfosMetas', response.data.metas);
      } catch (error) {
        console.log(error)
      }
    },
    async initArrayMedias({commit, state}, payload){
        try {
            const response = await getAllMedias(payload, state.apiKey);
            commit('initArrayMedias', response.data.medias),
            commit('initArrayFilters', response.data.aggregations)
            commit('initListItems', response.data.lists)
            commit('setTotalMedias', response.data.total)
            commit('setMediaDisplayed', {})
        } catch (error) {
          console.log('---------------- Erreur Init Media ---------------------');
          console.log(error)
        }
    },
    async filterArrayMedias({commit, state}, payload){
      try {
        const response = await getAllMedias(payload, state.apiKey);
        if(payload.from > 0){
          commit('addArrayMedias', response.data.medias);
        } else {
          commit('initArrayMedias', response.data.medias);
        }
        commit('setTotalMedias', response.data.total)
        commit('setMediaDisplayed', {})
      } catch (error) {
        console.log(error)
      }
    },
    async setMediaDetail({commit, state}, mediaId){
      try {
        const response = await getMediaById(mediaId, state.apiKey);
        commit('setMediaDetail', response.data.media)
      } catch (error) {
        console.log('---------------- Erreur Get Media ---------------------');
        console.log(error)
      }
    },
    async updateMediaDetails({commit, state}, payload){
      try {
        const response = await updateMediaById(payload.id, payload, state.apiKey)
        commit('updateMediaDetails', response.data.media)
      } catch (error) {
        console.log('---------------- Erreur Update ---------------------');
        console.log(error)
      }
    },
    sendNewMedia({commit, state}, payload){
      try {
        commit('addMediaToList', payload)
      } catch (error) {
        console.log('---------------- Erreur Upload Post ---------------------');
        console.log(error)
      }
    },
    async deleteMedia({commit, state}, mediaId){
      try {
        const response = await deleteMedia(mediaId, state.apiKey)
        commit('deleteMediaFromList', mediaId)
      } catch (error) {
        console.log('---------------- Erreur Delete Post ---------------------');
        console.log(error)
      }
    },
    updateMediaList({commit}, payload){
      commit('updateMediaList', payload)
    },
    setApiKey({commit}, payload){
      commit('setApiKey', payload)
    },
    setKeyIsValid({commit}, value){
      commit('setKeyIsValid', value)
    },
    setDialog({commit}, payload){
      commit('setDialog', payload)
    },
    setDialogCreate({commit}, payload){
      commit('setDialogCreate', payload)
    },
    setDialogGenerate({commit}, payload){
      commit('setDialogGenerate', payload)
    },
    setIsLogged({commit}, value){
      commit('setIsLogged', value)
    },
  },
  modules: {
  }
})
